import { Component, h, Host, Prop } from '@stencil/core';
import { Location } from '~model/location';

@Component({
  tag: 'uvex-location-location',
  styleUrl: 'location-location.scss',
})
export class LocationLocation {
  @Prop()
  location: Location;

  render() {
    return (
      <Host>
        <div class="row block">
          <span id={'c' + this.location.id} />
          <div class="col-xs-12 col-sm-6">{this.location.image && <img src={this.location.image} class="img-fluid" />}</div>
          <div class="col-xs-12 col-sm-6">
            <strong class="media-heading">{this.location.companyName}</strong>
            <p class="text-nl2br">{this.location.address}</p>
            <p>
              {this.location.phone && (
                <span>
                  <strong>T</strong> {this.location.phone}
                  <br />
                </span>
              )}
              {this.location.fax && (
                <span>
                  <strong>F</strong> {this.location.fax}
                  <br />
                </span>
              )}
              {this.location.email && (
                <span>
                  <strong>E</strong> <a href={'mailto:' + this.location.email}>{this.location.email}</a>
                  <br />
                </span>
              )}
            </p>
          </div>
        </div>
      </Host>
    );
  }
}
